import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-view-images',
  templateUrl: './view-images.component.html',
  styleUrl: './view-images.component.scss'
})
export class ViewImagesComponent implements OnInit {
  imageUrl: string;
  fileType: string;
  id: number = 0;
  safeSrcLink: SafeResourceUrl;
  loadingIndicator:boolean;

  // divisionForm: FormGroup;
  title: string;
  isLoading: boolean;
  loading: boolean;
  constructor(
    private activeModel: NgbActiveModal,
    private sanitizer: DomSanitizer
  ) {


  }



  ngOnInit(): void {
    this.title = "Veiw";
    // this.isLoading= true;

  }

  // show(type: string) {
  //   this.loading = true;
  //   this.fileType = type.startsWith('.') ? type : `.${type}`;
  //   if (this.fileType == '.pdf') {
  //     this.safeSrcLink = this.sanitizer.bypassSecurityTrustResourceUrl('https://docs.google.com/viewer?url=' + this.imageUrl + '&embedded=true');
  //   // this.loading = false;
  //   }
  //   // this.loading = false;
  //   // setTimeout(() => {
  //   // }, 2000);
  // }
  show(type: string) {
    this.loading = true; // Start loading
    
    this.fileType = type.startsWith('.') ? type : `.${type}`;
  
    if (this.fileType === '.pdf') {
      this.safeSrcLink = this.sanitizer.bypassSecurityTrustResourceUrl(
        'https://docs.google.com/viewer?url=' + this.imageUrl + '&embedded=true'
      );
      this.loading = false; // Stop loading after setting the PDF link
    } else {
      // Simulate a delay (optional) or immediately set loading to false
      setTimeout(() => {
        this.loading = false;
      }, 500); // Adjust time as needed
    }
  }
  
  close() {
    this.activeModel.close(false);
    this.loading = false;

  }

}
